module.exports = __webpack_public_path__ + "static/media/saayaHealthLogo.25018d29.webp";